export const newsList = [
  {
    id: "n1",
    title: "年度科幻巨制《星海征途》全球公映，首周票房突破十二亿",
    category: "影视新闻",
    publishTime: "2026-10-10",
    author: "四虎影讯",
    cover: "https://readdy.ai/api/search-image?query=Epic%20space%20premiere%20event%20with%20large%20glowing%20movie%20screen%20showing%20nebula%2C%20crowd%20silhouettes%20and%20cinema%20lighting%2C%20cool%20blue%20and%20orange%20accent%20tones%2C%20journalistic%20wide%20shot%2C%20high%20detail&width=800&height=500&seq=newscover-01&orientation=landscape",
    summary: "《星海征途》上映首周便横扫全球票房，口碑与热度双丰收，被媒体评价为近年来最具野心的太空题材作品。",
    content: [
      "由著名导演 Marcus Vale 执导的科幻巨制《星海征途》于本月正式全球公映，上映首周便斩获超过十二亿的票房成绩，成为年度最受瞩目的现象级作品。",
      "影片讲述了人类首次跨越虫洞寻找第二家园的故事，一支精英舰队在星际航行中遭遇未知文明的考验。宏大的世界观与细腻的人物情感，让不少观众在影院中数度落泪。",
      "业内影评人指出，《星海征途》在视觉特效与叙事节奏上都达到了国际一流水准，尤其是长达二十分钟的虫洞穿越长镜头，被誉为本年度大银幕最震撼的段落。",
      "据悉，片方已确认将启动续集计划，原班主创有望回归。更多关于影片的深度解析，请持续关注四虎视频的后续报道。",
    ],
    tags: ["科幻", "票房", "新片"],
  },
  {
    id: "n2",
    title: "深度影评：为什么《长夜将尽》是今年最被低估的悬疑片",
    category: "影评",
    publishTime: "2026-10-08",
    author: "影评人 · 陆沉",
    cover: "https://readdy.ai/api/search-image?query=Noir%20film%20review%20concept%20of%20rainy%20neon%20city%20street%20at%20night%20with%20reflections%2C%20moody%20dark%20blue%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20wide%20shot%2C%20high%20detail&width=800&height=500&seq=newscover-02&orientation=landscape",
    summary: "它没有炫目的特效，却用一个老刑警的执念，讲透了时间与救赎。今天我们聊聊这部安静却后劲十足的犯罪悬疑片。",
    content: [
      "在如今动辄大场面、高概念的市场环境里，《长夜将尽》显得格外克制。整部影片几乎没有激烈的追逐，却让人从头到尾屏住呼吸。",
      "导演陈牧远用大量的长镜头与留白，把观众拉进了一个潮湿、压抑的城市。霓虹灯下的每一个角落，都藏着不愿被触碰的旧事。",
      "影片最打动人的，是它对'执念'这个主题的处理。退休刑警追查的，或许不是真相本身，而是对自己过往的一种交代。",
      "如果你厌倦了套路化的反转，不妨走进《长夜将尽》。它更像是一杯需要慢慢品的酒，越到后面越有余味。",
    ],
    tags: ["影评", "悬疑", "深度"],
  },
  {
    id: "n3",
    title: "《长安十二时辰录》正式定档，古装悬疑再掀追剧热潮",
    category: "预告",
    publishTime: "2026-10-05",
    author: "四虎剧集",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20chinese%20city%20at%20dusk%20with%20countless%20lanterns%20and%20palace%20roofs%2C%20rich%20red%20and%20gold%20festival%20tones%2C%20epic%20historical%20wide%20shot%2C%20high%20detail&width=800&height=500&seq=newscover-03&orientation=landscape",
    summary: "备受期待的古装悬疑大剧《长安十二时辰录》官宣定档，首支预告片一经发布便引发全网热议。",
    content: [
      "由曹振执导，雷宇、易烊千城领衔主演的古装悬疑剧《长安十二时辰录》正式宣布定档，将于下月登陆各大平台。",
      "官方同步发布了长达两分钟的定档预告，上元灯会的盛景与暗流涌动的危机形成强烈反差，一句'十二个时辰，救一座城'瞬间点燃观众期待。",
      "从已曝光的物料来看，剧集在服化道与场景搭建上投入巨大，力求还原盛唐气象。业内人士普遍看好其成为下一部现象级古装剧。",
      "更多定档资讯与角色海报，四虎视频将持续跟进报道。",
    ],
    tags: ["古装", "定档", "预告"],
  },
  {
    id: "n4",
    title: "治愈系日剧《山居食记》热播，慢生活题材为何如此治愈人心",
    category: "影评",
    publishTime: "2026-10-02",
    author: "影评人 · 木棉",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20countryside%20kitchen%20with%20steaming%20homemade%20food%20on%20wooden%20table%20and%20sunlight%20through%20window%2C%20warm%20green%20and%20amber%20tones%2C%20peaceful%20healing%20wide%20shot%2C%20high%20detail&width=800&height=500&seq=newscover-04&orientation=landscape",
    summary: "没有激烈冲突，没有狗血反转，只有一日三餐与四季流转。《山居食记》用最简单的方式，安抚了无数疲惫的心。",
    content: [
      "《山居食记》讲述一位厌倦都市的料理人回到深山开设小食堂的故事。整部剧节奏舒缓，像是一封写给慢生活的情书。",
      "每一集都会围绕一道应季料理展开，食物成了串联人物情感的线索。观众在看剧的同时，也仿佛完成了一次心灵的休憩。",
      "在快节奏的时代，这样一部'慢'剧的走红并非偶然。它提醒我们，幸福有时就是一碗热汤、一次日落。",
      "如果你最近感到疲惫，不妨看看这部剧，让山间的炊烟替你按下暂停键。",
    ],
    tags: ["治愈", "日剧", "慢生活"],
  },
  {
    id: "n5",
    title: "暑期档票房报告出炉：国产片占据前十中的八席",
    category: "影视新闻",
    publishTime: "2026-09-28",
    author: "四虎影讯",
    cover: "https://readdy.ai/api/search-image?query=Box%20office%20report%20concept%20of%20a%20movie%20theater%20entrance%20with%20glowing%20marquee%20and%20ticket%20booth%20at%20night%2C%20warm%20amber%20and%20red%20tones%2C%20data%20journalism%20wide%20shot%2C%20high%20detail&width=800&height=500&seq=newscover-05&orientation=landscape",
    summary: "最新暑期档票房数据显示，国产影片表现强劲，占据票房榜前十中的八个席位，类型题材更加多元。",
    content: [
      "随着暑期档落幕，最新票房报告正式出炉。数据显示，今年暑期档总票房较去年同期稳步增长，观影人次重回高位。",
      "值得关注的是，国产影片在本次档期中表现尤为抢眼，前十席位中占据了八席，题材覆盖科幻、喜剧、犯罪、家庭等多个方向。",
      "分析师认为，观众对本土故事与真实情感的共鸣，是国产片持续走强的关键因素。与此同时，中小成本影片也凭借口碑实现了逆袭。",
      "接下来国庆档与贺岁档的表现，将决定全年票房能否再创新高。",
    ],
    tags: ["票房", "行业", "国产片"],
  },
  {
    id: "n6",
    title: "《权力之巅》收官，政治惊悚剧为何总能长盛不衰",
    category: "影评",
    publishTime: "2026-09-25",
    author: "影评人 · 高远",
    cover: "https://readdy.ai/api/search-image?query=Political%20thriller%20concept%20of%20an%20empty%20capitol%20corridor%20with%20cold%20light%20and%20long%20shadows%2C%20steel%20blue%20and%20gold%20tones%2C%20tense%20cinematic%20wide%20shot%2C%20high%20detail&width=800&height=500&seq=newscover-06&orientation=landscape",
    summary: "长达五季的政治惊悚剧《权力之巅》迎来最终章。它之所以让人欲罢不能，靠的绝不只是权谋本身。",
    content: [
      "《权力之巅》正式收官，这部横跨五季的作品用一场场惊心动魄的博弈，为观众呈现了权力世界的残酷与复杂。",
      "剧集的高明之处，在于它始终把镜头对准'人'。那些身处高位者，同样会恐惧、会犹豫、会在深夜怀疑自己的选择。",
      "政治惊悚剧之所以长盛不衰，或许正是因为权力与人性之间的张力，永远能引发观众的思考与讨论。",
      "结局是否圆满众说纷纭，但可以确定的是，这部剧留下的讨论远未结束。",
    ],
    tags: ["政治", "美剧", "剧评"],
  },
  {
    id: "n7",
    title: "多部影片宣布调档，国庆档竞争格局生变",
    category: "影视新闻",
    publishTime: "2026-09-20",
    author: "四虎影讯",
    cover: "https://readdy.ai/api/search-image?query=Film%20release%20calendar%20concept%20of%20cinema%20lobby%20with%20poster%20walls%20and%20warm%20spotlights%2C%20orange%20and%20deep%20blue%20tones%2C%20industry%20news%20wide%20shot%2C%20high%20detail&width=800&height=500&seq=newscover-07&orientation=landscape",
    summary: "临近国庆档，多部影片临时调整上映计划，让原本就拥挤的档期竞争更添变数，也让观众选择更加丰富。",
    content: [
      "近日，多部原定于国庆档上映的影片宣布调整档期，其中包括若干备受期待的大制作。业内认为，这是片方在激烈竞争下的策略调整。",
      "有分析指出，档期的高度集中让单部影片的排片空间被压缩，错峰上映反而有利于长线口碑的发酵。",
      "对于观众而言，这意味着接下来一段时间将有更多类型各异的影片可供选择。",
      "四虎视频将第一时间更新最新的定档与调档信息，敬请留意。",
    ],
    tags: ["档期", "行业", "新片"],
  },
  {
    id: "n8",
    title: "从《冰封之城》看灾难片的进化：特效之外更需情感内核",
    category: "影评",
    publishTime: "2026-09-15",
    author: "影评人 · 白鹭",
    cover: "https://readdy.ai/api/search-image?query=Frozen%20apocalyptic%20city%20covered%20in%20snow%20and%20ice%20under%20grey%20sky%2C%20cold%20blue%20and%20white%20chilling%20tones%2C%20dramatic%20disaster%20wide%20shot%2C%20high%20detail&width=800&height=500&seq=newscover-08&orientation=landscape",
    summary: "当灾难片的视觉奇观越来越常见，真正能让观众记住的，往往是绝望之中那一点人性的微光。",
    content: [
      "《冰封之城》以一场极寒灾难为背景，把镜头对准了被困在地铁站里的一群普通人。",
      "影片的特效无疑是出色的，但真正撑起整部作品的，是角色之间逐渐建立的信任与牺牲。",
      "灾难片的进化方向，正在从单纯的视听冲击，转向对人性与共同体的深入探讨。",
      "当零下五十度的世界里只剩下彼此的体温，那些平凡人的选择，才构成了灾难片最动人的内核。",
    ],
    tags: ["灾难", "韩影", "情感"],
  },
];